import { useContext, useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import AppContext from "../../context";
import Meta from "../components/Meta";
import Data from "./Data";

const ServicePreview = ({ service }) => {
    const formatPrice = (price) => price === 0 ? 'Free' : `£${(price / 100).toFixed(2)}`;

    return (
        <Link to={`/services/${service._id}`} className={"block rounded-lg overflow-hidden border hover:shadow-md transition-shadow"}>
            <div className={"aspect-video bg-gray-100 flex items-center justify-center overflow-hidden"}>
                {service.image ?
                    <img src={service.image} alt={service.name} className={"w-full h-full object-cover"} />
                    : <div className={"text-5xl text-gray-300"}>{service.name.charAt(0)}</div>
                }
            </div>
            <div className={"p-4"}>
                <h3 className={"font-semibold"}>{service.name}</h3>
                {service.description && (
                    <p className={"text-textGrey text-sm mt-1 line-clamp-2"}>{service.description}</p>
                )}
                <div className={"flex gap-2 mt-2 text-sm text-textGrey"}>
                    <span>{service.duration} mins</span>
                    <span>•</span>
                    <span>{formatPrice(service.price)}</span>
                </div>
            </div>
        </Link>
    );
};

const Services = () => {
    const context = useContext(AppContext);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(async () => {
        try {
            const res = await Data.fetchServices();
            setServices(res.data);
            setError(false);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, []);

    return (
        <>
            <Meta title={context.domain.heading || context.domain.name} />
            <Outlet />
            <div>
                <div className={"w-full h-60 bg-primary flex items-center relative overflow-hidden"}>
                    <div className={"p-6 [&_*]:text-white container mx-auto z-10 relative"}>
                        <h1 className={"text-4xl"}>{context.domain.heading || context.domain.name}</h1>
                        {context.domain.subHeading && <p className={"mt-2"}>{context.domain.subHeading}</p>}
                    </div>
                    {context.domain.backgroundImage
                        ? <img src={context.domain.backgroundImage} alt={""} className={"absolute z-0 opacity-30 w-full h-full object-cover"} />
                        : null
                    }
                </div>

                <div className={"p-6 lg:py-16 container mx-auto"}>
                    <h2 className={"mb-4"}>Services</h2>

                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p>There was an error loading services, please refresh the page.</p>
                    ) : services.length === 0 ? (
                        <p>We don't currently have any services available.</p>
                    ) : (
                        <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"}>
                            {services.map(service => <ServicePreview key={service._id} service={service} />)}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Services;
